import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IMap } from '@obvious.tech/constellation'

export const Map = defineEntity('Map', {
  endpoint: 'cartography/api/Map',
  schema: SNoop<IMap>(),
})
